var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:( _obj = {'controls-share': true, dark: _vm.isDark}, _obj[_vm.size] = _vm.size, _obj.disabled = _vm.isDisabled, _obj.open = _vm.shareOpen, _obj ),attrs:{"disabled":_vm.isDisabled},on:{"click":_vm.toggleShare}},[_c('span',{staticClass:"menu-text"},[_vm._v("Share")])])}
var staticRenderFns = []

export { render, staticRenderFns }